const entryScript = import.meta.env.DEV
  ? null
  : document.querySelector<HTMLScriptElement>('script[type="module"][src]');

export const CLIENT_BUILD = entryScript ? new URL(entryScript.src).pathname : null;
